import React, { useState, useCallback } from 'react';
import { Checkbox } from "@lk-gtcom/ecomlab-components";
import { TooltipBlack } from '../../../components/Tooltip/TooltipBlack/TooltipBlack';
import { user_light_grey } from '../../../common/svg_img';
import { ExecutorPlaceholder } from '../../../components/OptionsExecutor/OptionsExecutor';
import users_icon from './img/bx-user-check.svg';
import { ReactComponent as Low } from './img/Low.svg';
import { ReactComponent as Medium } from './img/medium.svg';
import { ReactComponent as High } from './img/hight.svg';
import { ButtonActionDrop } from '../../../components/Buttons/ButtonActionDrop/ButtonActionDrop';
import "./TaskItem.scss";
import { TextPage } from '../../../components/TextPage/TextPage';
import useGeneralStore from '../../../store/general';
import customHeaders, { getSpace } from '../../../common/headers';
import { usePushNotifications } from '../../../common/pushNotification';
import ModalWarning from '../../../components/Modal/ModalWarning/ModalWarning';

type Priority = 'Высокий' | 'Средний' | 'Низкий' | 'Не назначено';
type Status = 'НА СТОПЕ' | 'НОВЫЕ ЗАДАЧИ' | 'В РАБОТЕ' | 'НА ПРОВЕРКЕ' | 'ГОТОВО' | string;

interface User {
  name?: string;
  login?: string;
  [key: string]: any;
}

interface СurrentCount {
  count_expired?: number;
  count_not_closed?: number;
  deal_id?: number;
  task_list_id?: string
}

interface TaskItemProps {
  link?: string;
  author?: User;
  projectName?: string;
  projectId?: string | number;
  title: string;
  priority: Priority;
  status: Status;
  executor?: User;
  time: string;
  style?: React.CSSProperties;
  id: number;
  done: boolean;
  openTask?: () => void;
  deleteTask: (id: number) => void;
  isOpenActiveMenu?: boolean;
  setIsOpenActiveMenu?: (value: boolean) => void;
  isShowAuthor?: boolean;
  taskId?: number;
  count_unread_comments?: number;
  isVisibleCheckbox?: boolean;
  setListPrint?: React.Dispatch<React.SetStateAction<number[]>>;
  listPrint?: number[];
  currentCount?: СurrentCount
  isDelete?: boolean
  isTrash?: boolean
  crm?: boolean
  ticket?: boolean
  task?: boolean
  isUpdateColumn?: boolean
  setIsUpdateColumn?: (value: boolean) => void;
}

const TaskItem: React.FC<TaskItemProps> = ({
  projectId,
  author,
  title,
  priority,
  status,
  executor,
  time,
  id,
  done = false,
  deleteTask,
  isShowAuthor,
  count_unread_comments = 0,
  isVisibleCheckbox,
  setListPrint,
  listPrint = [],
  currentCount,
  isDelete = false,
  isTrash = false,
  crm = false,
  ticket = false,
  task = false,
  isUpdateColumn = false,
  setIsUpdateColumn = () => { }
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();

  const colorTime = useCallback((priority: Priority) => {
    switch (priority) {
      case 'Высокий':
        return <High />;
      case 'Средний':
        return <Medium />;
      case 'Низкий':
        return <Low />;
      default:
        return <Low />;
    }
  }, []);

  const colorStatus = useCallback((status: Status) => {
    switch (status) {
      case 'НА СТОПЕ':
        return 'info-status-color_red';
      case 'НОВЫЕ ЗАДАЧИ':
        return 'info-status-color_grey';
      case 'В РАБОТЕ':
        return 'info-status-color_blue';
      case 'НА ПРОВЕРКЕ':
        return 'info-status-color_yellow';
      case 'ГОТОВО':
        return 'info-status-color_green';
      default:
        return 'info-status-color_grey';
    }
  }, []);

  const [isDone, setIsDone] = useState(done);
  const [isModalDeleteTask, setIsModalDeleteTask] = useState(false);
  const email = localStorage.getItem('email');
  const taskProjectId = projectId ?? Number(sessionStorage.getItem(crm ? 'crmProjectId' :
    (ticket ? 'ticketProjectId' : 'crmProjectId')));

  const handlePrintCheckboxChange = useCallback((checked: boolean) => {
    setListPrint?.((prevItems) =>
      checked
        ? [...prevItems, id]
        : prevItems.filter((prevItem) => prevItem !== id)
    );
  }, [id, setListPrint]);

  // Каунтер для сделок
  const fetchRestore = () => {
    let url = ` https://portals.ecomru.ru/api/v3/tasks/restore_event?event_id=${id}`

    fetch(url, { headers })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('bad events response');
        }
      })
      .then((json) => {
        addSuccessPush(`Задача ID-${id} восстановлена`)
        setTimeout(() => setIsUpdateColumn(!isUpdateColumn), 100)
      })
      .catch((err) => {
        addErrorPush(`Не удалось восстановить задачу ID-${id}`)
        console.error(err);
      })
  };

  const btns = [
    isTrash ?
      {
        btn: 'Восстановить',
        func: () => {
          if (task) {
            fetchRestore()
          }
        }
      }
      :
      {
        btn: 'Удалить',
        func: () => setIsModalDeleteTask(true),
      }
  ];

  return (
    <>
      {isModalDeleteTask &&
        <ModalWarning
          headerText='Подтвердите удаление'
          messageText={`Удалить “${title || 'Нет названия'}”?`}
          approveButtonText='Удалить'
          cancelButtonText='Отмена'
          colorBtn='red'
          onApproveClick={() => {
            deleteTask(id)
            setIsModalDeleteTask(false)
          }}
          onCancelClick={() => setIsModalDeleteTask(false)}
        />
      }

      <div
        className='task-item'
        style={{ cursor: (taskProjectId == -1) ? 'pointer' : '' }}
      >
        <div className='task-item__top-content'>
          <p className='task-item__id'>
            {isShowAuthor && (
              <div className='members-list-box'>
                {author?.name
                  ? <ExecutorPlaceholder {...author} email={author?.login} />
                  : <img src={user_light_grey} alt="User" />}
              </div>
            )}
            {`ID-${id}`}
          </p>
          {count_unread_comments > 0 && (
            <span className='task-item__count'>{count_unread_comments}</span>
          )}
          {((author?.login === email) || isDelete) && (
            <ButtonActionDrop id={id} btns={btns} size='s' />
          )}
        </div>

        <div className='task-item__content'>
          <div className='info-container'>
            <p
              className='text'
              style={isDone ? { textDecoration: 'line-through' } : {}}
            >
              {title || 'Нет названия'}
            </p>

            {(crm && (taskProjectId != -1)) ?
              <div className='task-item__status-count'>
                <TextPage
                  text={<>
                    Просрочено: <span style={{ fontWeight: 700, color: '#000000' }}>{currentCount?.count_expired}</span> <br />
                    Не закрыто: <span style={{ fontWeight: 700, color: '#000000' }}>{currentCount?.count_not_closed}</span>
                  </>}
                  style={{ fontSize: '11px', color: '#858585' }}
                />
              </div>
              : null}

            <div className='task-item__bottom-content'>
              {(taskProjectId == -1 && status) && (
                status?.length > 11 ? (
                  <TooltipBlack
                    text={status}
                    top='18px'
                    left='0px'
                    child={
                      <div className={colorStatus(status)}>
                        <p>{status}</p>
                      </div>
                    }
                  />
                ) : (
                  <div className={colorStatus(status)}>
                    <p>{status}</p>
                  </div>
                )
              )}

              <div className='task-item__bottom-info'>
                <div className='task-item__executors-list'>
                  <img src={users_icon} alt="Users" />
                  {executor?.name
                    ? <ExecutorPlaceholder {...executor} email={executor?.login} />
                    : <img className='task-item__img-user' src={user_light_grey} alt="User" />}
                </div>

                <div className='task-item__bottom-info-right'>
                  {priority !== 'Не назначено' && (
                    <div className='priority'>
                      {colorTime(priority)}
                    </div>
                  )}
                  <p className='task-item__date'>{time.split('г.')[0]}</p>

                  {/* Чекбокс */}

                  {/* <Checkbox
                    green
                    onChange={() => { }}
                    value={isDone}
                  /> */}
                </div>
              </div>

              {isVisibleCheckbox && (
                <div className='task-item__bottom-info'>
                  <Checkbox
                    blue
                    value={listPrint.includes(id)}
                    onChange={handlePrintCheckboxChange}
                  >
                    Печать
                  </Checkbox>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskItem;